/* @flow */
import gql from 'graphql-tag';
import idx from 'idx';
import classesDefaultsFragment from 'groups/fragments/classesDefaultsFragment.gql';
import Group from 'entities/Group';
import GroupStore from 'groups/stores/GroupStore';
import RemindAPI from 'lib/RemindAPI';
import { rootGroupCode } from 'entities/RootGroup.js';

export function loadGroupByCode(groupCode: string, forceFetch?: boolean = false): Promise<?Group> {
  const GROUP_BY_CODE_QUERY = gql`
    ${classesDefaultsFragment}

    query LoadGroupByCode($code: String!) {
      classes(codes: [$code]) {
        ...classesDefaults
      }
    }
  `;

  // this is critical for the root group,
  // as it is always returned here.
  if (!forceFetch || groupCode === rootGroupCode) {
    const group = GroupStore.getGroupForCode(groupCode);
    if (group) {
      return Promise.resolve(group);
    }
  }

  return RemindAPI.execute({
    query: GROUP_BY_CODE_QUERY,
    variables: { code: `@${groupCode}` },
    forceFetch,
  }).then(
    res => {
      return Group.fromJSON(res.classes[0]);
    },
    err => {
      const code = idx(err.graphQLErrors[0], _ => _.serviceMetadata.service_response.code);

      if (code === 'class_not_found') {
        return null;
      }

      console.warn(err);
      console.error('LoadGroupByCode failure');
      throw err;
    }
  );
}
